export interface ProviderContact {
  id: string;
  name: string;
  role: string;
  email: string;
  phone: string;
  is_primary: boolean;
}

export interface ServiceLocation {
  id: string;
  city: string;
  postal_code: string;
  radius_km: number;
}

export interface ProviderFormState {
  company_name: string;
  legal_name: string;
  contact_name: string;
  contact_role: string;
  contact_email: string;
  phone: string;
  website: string;
  invoice_email: string;
  address_line1: string;
  postal_code: string;
  city: string;
  country: string;
  vat_id: string;
  geschaeftsfuehrer: string;
  gruendungsjahr: string;
  bonitaet_rating: string;
  region: string;
  service_regions: string[];
  service_locations: ServiceLocation[];
  remote_supported: boolean;
  sla_tier: string;
  sla_response_hours: number;
  weekly_lead_limit: number;
  monthly_opportunity_limit: number;
  categories: string[];
  selectedStackTags: string[];
  quality_score: number;
  acceptance_rate: number;
  avg_response_time_hours: number;
  is_approved: boolean;
  billing_status: string;
  // Zugangsdaten
  create_account: boolean;
  login_email: string;
  initial_password: string;
  portal_access_enabled: boolean;
  // Kontakte
  contacts: ProviderContact[];
}

export const INITIAL_FORM_STATE: ProviderFormState = {
  company_name: "",
  legal_name: "",
  contact_name: "",
  contact_role: "",
  contact_email: "",
  phone: "",
  website: "",
  invoice_email: "",
  address_line1: "",
  postal_code: "",
  city: "",
  country: "DE",
  vat_id: "",
  geschaeftsfuehrer: "",
  gruendungsjahr: "",
  bonitaet_rating: "",
  region: "",
  service_regions: [],
  service_locations: [],
  remote_supported: false,
  sla_tier: "NBD",
  sla_response_hours: 24,
  weekly_lead_limit: 5,
  monthly_opportunity_limit: 20,
  categories: [],
  selectedStackTags: [],
  quality_score: 0.8,
  acceptance_rate: 0.9,
  avg_response_time_hours: 4,
  is_approved: false,
  billing_status: "active",
  create_account: true,
  login_email: "",
  initial_password: "",
  portal_access_enabled: true,
  contacts: [],
};

export const REGIONS = [
  "Baden-Württemberg", "Bayern", "Berlin", "Brandenburg", "Bremen", "Hamburg",
  "Hessen", "Mecklenburg-Vorpommern", "Niedersachsen", "Nordrhein-Westfalen",
  "Rheinland-Pfalz", "Saarland", "Sachsen", "Sachsen-Anhalt",
  "Schleswig-Holstein", "Thüringen", "DACH-weit",
];

export const SERVICE_CATEGORIES = [
  { value: "managed_service", label: "Wartungsvertrag" },
  { value: "project", label: "Bauprojekt" },
  { value: "security", label: "Notdienst" },
  { value: "cloud", label: "Sanierung & Modernisierung" },
  { value: "support", label: "Kleinreparatur" },
];

export type Tab = "stammdaten" | "kontakte" | "service" | "zugangsdaten";

export const TABS: { id: Tab; label: string }[] = [
  { id: "stammdaten", label: "Stamm- & Adressdaten" },
  { id: "kontakte", label: "Kontaktdaten" },
  { id: "service", label: "Service & Matching" },
  { id: "zugangsdaten", label: "Zugangsdaten" },
];
